import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

import PinnedContainerActions from './pinned-container-actions';

const initialState = Immutable({ pinnedContainers: [], isLoading: false });

const reducer = createReducer((on) => {
  on(PinnedContainerActions.fetch, (state) => state.set('isLoading', true));
  on(PinnedContainerActions.fetchSuccess, (state, { pinnedContainers }) =>
    state.merge({
      isLoading: false,
      pinnedContainers,
    })
  );
  on(PinnedContainerActions.fetchFailure, (state) => state.set('isLoading', false));
}, initialState);

export default reducer;
